import React from 'react';
import '../styles/welcome.css'

const WelcomeSection = () => {
  return (
    <div className="welcome-container">
      {/* Welcome Section */}
      <div className="welcome-section">
        <h1>Welcome to Smartstone</h1>
        <p>
          Thanks for visiting our new website. Perhaps you’re an interior designer or architect seeking the perfect stone
          benchtop for a client project, or an excited first-time renovator — or maybe you’re still at the dreaming stage.
          Whatever the story behind your visit, let us guide you in making an informed decision and an inspired surface choice.
        </p>
      </div>

      {/* Info Section 
      <div className="info-section1">
        <div className="info-box">
          <h3>Quality, set in stone</h3>
          <p>Get to know Smartstone, UAE’s leading wholesaler of stone surfaces since 2008.</p>
        </div>
        <div className="info-box">
          <h3>Beautiful. Durable. Affordable.</h3>
          <p>Discover the perfect blend of elegance, strength, and affordability with our premium stone surfaces, designed to elevate any space without compromising on quality.</p>
        </div>
        <div className="info-box">
          <h3>Indoor-outdoor style</h3>
          <p>See how our stone benchtop's next-level durability enables limitless surface applications.</p>
        </div>
      </div>*/}
    </div>
  );
};

export default WelcomeSection;
